var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAgriculture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_1602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 161
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#5D38E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_1602)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4895 132.401H106.532",
    stroke: "#5D38E5",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5566 132.402L77.8853 119.073C79.6142 117.344 82.4287 117.344 84.1576 119.073L97.4863 132.402",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6022 77.036C77.6638 83.7707 81.4634 93.6818 80.7798 103.412C71.3312 105.804 60.8974 103.814 52.8359 97.0793C44.7944 90.3446 40.9948 80.4335 41.6784 70.7034C51.127 68.3111 61.5608 70.3013 69.6223 77.036H69.6022Z",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6782 70.7039L80.7998 103.412",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9778 77.036C83.9162 83.7707 80.1167 93.6818 80.8002 103.412C90.2489 105.804 100.683 103.814 108.744 97.0793C116.806 90.3446 120.605 80.4335 119.922 70.7034C110.473 68.3111 100.039 70.3013 91.9778 77.036V77.036Z",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.902 70.7039L80.8 103.412",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.08 55.0113C99.0542 63.7362 90.2086 68.8828 80.8604 69.5864C76.7794 61.163 76.7995 50.9303 81.8455 42.2053C86.8915 33.4603 95.717 28.3137 105.065 27.6101C109.146 36.0335 109.126 46.2662 104.08 54.9912V55.0113Z",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0215 117.787V102.789",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8801 71.5078V94.6269",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8801 69.5864L105.065 27.6101",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.916 42.1852C74.87 33.4603 66.0244 28.3137 56.6964 27.6101C52.6153 36.0335 52.6354 46.2662 57.6814 54.9912C62.7073 63.7161 71.5529 68.8627 80.9011 69.5663",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8807 69.5864L56.696 27.6101",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgriculture);
export default __webpack_public_path__ + "static/media/icon_agriculture.c8420ba0dad17a274ad98ff6f0c71b35.svg";
export { ForwardRef as ReactComponent };